import { useMemo } from 'react';
import { ChatOptionsProps } from '../ChatOptions.types';
import type { SentinelOptions as Options } from './SentinelOptions.types';
import { useOptionsManager } from '../hooks/useOptionsManager';
import { DEFAULT_SELECTABLE_MODEL, useAgentModelOptions } from '../hooks/useAgentModelOptions';

const getDefaultOptions = ({ model }: Pick<Options, 'model'>): Options => ({
  model,
  selectedGuidelineIds: [],
});

/**
 * Transforms Sentinel options before storing in chat input
 */
const toStoreOptions = (options: Options) => ({
  ...options,
  llmOptions: {
    model: options.model,
  },
});

export const SentinelOptions = ({ onOptionUpdated }: ChatOptionsProps) => {
  const filteredModels = useAgentModelOptions();

  const defaultOptions = useMemo(() => {
    const firstModel = filteredModels[0]?.value ?? DEFAULT_SELECTABLE_MODEL;
    return getDefaultOptions({ model: firstModel });
  }, [filteredModels]);

  useOptionsManager({
    defaultOptions,
    onOptionUpdated,
    toStore: toStoreOptions,
  });

  // The model selector lives in the right-side AI Model Selector on the
  // ChatInput configuration bar, so this settings popup has nothing to render.
  return null;
};
